<template>
  <div>
    <div class="left-top">
      <div class="centerBottom">
        <div class="detail-list">
          <div
            class="detail-list-item"
            v-for="(item, index) in detailsList"
            :key="index"
          >  <img
                  :src="
                    require(`../../../assets/left/jigou${index +
                      1}.png`)
                  "
                  :alt="item.title"
                />
            <div class="detail-item-text">
              <h3>{{ item.title }}</h3>
              <span>{{ item.number }}</span>
              <span class="unit">{{ item.unit }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detailsList: [
        {
          title: "自营机构",
          number: "25",
          unit: "家",
        },
        {
          title: "赋能机构",
          number: "128",
          unit: "家",
        },
      ],
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.module-title {
  padding: 18px 10px 0 10px;
  color: #bcdcff;
  font-size: 1rem;
  font-weight: bold;
  .iconfont {
    font-size: 0.875rem;
    margin-right: 0.625rem;
    color: #89e5ff;
    font-weight: 400;
  }
}
.left_dang_source {
  width: 27.675rem;
  height: 14.5rem;
}
.left_today {
  width: 27.675rem;
  height: 12rem;
}
.left_dang {
  width: 27.675rem;
  height: 11rem;
}
.user-data {
  width: 28.375rem;
  height: 34.375rem;
}

.item-box {
  & > div {
    padding-right: 5px;
  }
  font-size: 10px;
  float: right;
  position: relative;
  width: 32%;
  color: #d3d6dd;
  .dv-digital-flop {
    width: 100%;
    height: 30px;
  }
  // 金币
  .coin {
    position: relative;
    top: 6px;
    font-size: 20px;
    color: #ffc107;
  }
  .colorYellow {
    color: yellowgreen;
  }
  p {
    text-align: center;
  }
}

.centerBottom {
  padding: 0.2rem 0.7rem;
  .detail-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: space-between;
    justify-content: space-around;
    width: 100%;
    &-item {
      display: flex;
      align-items: center;
      position: relative;
      height: 4.75rem;
      width: 46%;
      padding: 0 1.2rem;
      margin-bottom: 0.4rem;
      margin-top: 0.2rem;
      border-radius: 5px;
      border: 1px solid #343f4b;
      background-color: rgba(19, 25, 47, 0.8);
      img {
        width: 4rem;
        height: 4rem;
      }
      .detail-item-text {
        margin-left: 0.625rem;
        h3 {
          color: #bcdcff;
          font-size: 0.25rem;
          margin-bottom: 0.3rem;
        }
        span {
          font-weight: 500px;
          font-size: 0.25rem;
          font-weight: bolder;
          background: linear-gradient(to bottom, #fff, #4db6e5);
          color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
        .unit {
          font-size: 0.25rem;
          margin-left: 0.625rem;
        }
      }
    }
  }
}
</style>
